import React, { useState, useEffect } from 'react';
import { Modal, Typography, Checkbox, Form } from '../../';
import { CreatableSelect } from '../../CreatableSelect';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import './SendToMigrationModal.scss';

const { Text } = Typography;

export const SendToMigrationModal = ({
    open,
    onCancel,
    onContinue,
    showMoveGroupAssignment = false,
    moveGroups = [],
}) => {
    const [form] = Form.useForm();
    const [assignToMoveGroup, setAssignToMoveGroup] = useState(false);

    useEffect(() => {
        if (!open) {
            form.resetFields();
            setAssignToMoveGroup(false);
        }
    }, [open, form]);

    const handleCheckboxChange = (e) => {
        setAssignToMoveGroup(e.target.checked);
        if (!e.target.checked) {
            form.setFieldsValue({ moveGroup: undefined });
        }
    };

    const handleContinue = async () => {
        if (showMoveGroupAssignment && assignToMoveGroup) {
            try {
                const values = await form.validateFields();
                onContinue({ assignToMoveGroup: true, moveGroupValue: values.moveGroup });
            } catch (error) {
                return;
            }
        } else {
            onContinue({ assignToMoveGroup: false });
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setAssignToMoveGroup(false);
        onCancel();
    };

    // Removed for release-131
    // if (showMoveGroupAssignment) {
    //     return (
    //         <Modal
    //             className="send-to-migration-modal assign-mode"
    //             title={
    //                 <div className="warning-modal-header">
    //                     <ExclamationCircleOutlined className="warning-modal-icon" />
    //                     <span>Notice</span>
    //                 </div>
    //             }
    //             open={open}
    //             onCancel={handleCancel}
    //             onOk={handleContinue}
    //             okText="Continue"
    //             cancelText="Cancel"
    //             width={700}
    //             okButtonProps={{ shape: 'round' }}
    //             cancelButtonProps={{ shape: 'round' }}
    //         >
    //             <Text className="modal-description">
    //                 Some of the selected machines are not assigned to a Move Group. Would you like to continue?
    //             </Text>

    //             <Form form={form} layout="vertical" className="assign-form">
    //                 <Checkbox
    //                     checked={assignToMoveGroup}
    //                     onChange={handleCheckboxChange}
    //                     className="assign-checkbox"
    //                 >
    //                     Assign to Move Group
    //                 </Checkbox>

    //                 {assignToMoveGroup && (
    //                     <Form.Item
    //                         name="moveGroup"
    //                         className="move-group-select-item"
    //                         rules={[{ required: true, message: 'Please select a move group' }]}
    //                     >
    //                         <CreatableSelect
    //                             selectPlaceholder="Select Move Group"
    //                             addItemPlaceholder="Create new Move Group"
    //                             options={moveGroups}
    //                             onChange={(value) => form.setFieldsValue({ moveGroup: value })}
    //                         />
    //                     </Form.Item>
    //                 )}
    //             </Form>
    //         </Modal>
    //     );
    // }

    return (
        <Modal
            className="send-to-migration-modal"
            title="Send to Migration Platform"
            open={open}
            onCancel={onCancel}
            onOk={onContinue}
            okText="Continue"
            cancelText="Cancel"
            width={700}
            okButtonProps={{ shape: 'round' }}
            cancelButtonProps={{ shape: 'round' }}
        >
            <Text>
                The selected machines will be added to the migration platform for scheduling, optimization and
                migration. Source systems will not be modified at this time.
            </Text>
        </Modal>
    );
};
